(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["announcement"]) return;
  try {
    

if (window.matchMedia('(min-width: 800px)').matches) {
  // polyfill
  window.requestAnimationFrame = (function(){
    return  window.requestAnimationFrame       ||
            window.webkitRequestAnimationFrame ||
            window.mozRequestAnimationFrame    ||
            function( callback ){
              window.setTimeout(callback, 1000 / 60);
            };
  })();


  var speed = 10000;
  (function currencySlide(){
      var currencyPairWidth = $('.slideItem:first-child').outerWidth();
      $(".slideContainer").animate({marginLeft:-currencyPairWidth},speed, 'linear', function(){
                  $(this).css({marginLeft:0}).find("li:last").after($(this).find("li:first"));
          });
          requestAnimationFrame(currencySlide);
  })();

}
document.addEventListener('DOMContentLoaded', () => {

  const d = new Date();
  let day = d.getDay()
  let hiddenAnnouncements = document.querySelector(".hidden-announcements");
  let overrideText =  document.querySelector(".hidden-announcements__override").textContent;

  if (overrideText) {
    document.querySelector(".hours-info").textContent=overrideText;
  } else if (day==1) {
    let hiddenAnnouncementText = hiddenAnnouncements.querySelector('.hidden-announcements__monday').textContent;
    if (hiddenAnnouncementText) {
      document.querySelector(".hours-info").textContent=hiddenAnnouncementText;
    }
  } else if (day==2) {
    let hiddenAnnouncementText = hiddenAnnouncements.querySelector('.hidden-announcements__tuesday').textContent;
    if (hiddenAnnouncementText) {
      document.querySelector(".hours-info").textContent=hiddenAnnouncementText;
    }
  } else if (day==3) {
    let hiddenAnnouncementText = hiddenAnnouncements.querySelector('.hidden-announcements__wednesday').textContent;
    if (hiddenAnnouncementText) {
      document.querySelector(".hours-info").textContent=hiddenAnnouncementText;
    }
  } else if (day==4) {
    let hiddenAnnouncementText = hiddenAnnouncements.querySelector('.hidden-announcements__thursday').textContent;
    if (hiddenAnnouncementText) {
      document.querySelector(".hours-info").textContent=hiddenAnnouncementText;
    }
  } else if (day==5) {
    let hiddenAnnouncementText = hiddenAnnouncements.querySelector('.hidden-announcements__friday').textContent;
    if (hiddenAnnouncementText) {
      document.querySelector(".hours-info").textContent=hiddenAnnouncementText;
    }
  } else if (day==6) {
    let hiddenAnnouncementText = hiddenAnnouncements.querySelector('.hidden-announcements__saturday').textContent;
    if (hiddenAnnouncementText) {
      document.querySelector(".hours-info").textContent=hiddenAnnouncementText;
    }
  } else if (day==0) {
    let hiddenAnnouncementText = hiddenAnnouncements.querySelector('.hidden-announcements__sunday').textContent;
    if (hiddenAnnouncementText) {
      document.querySelector(".hours-info").textContent=hiddenAnnouncementText;
    }
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["events-landing"]) return;
  try {
    


document.addEventListener('DOMContentLoaded', () => {
  let events = document.querySelectorAll('.hidden-events__event-item-wrapper');
  let upcomingEventsWrapper = document.querySelector('.upcoming-events-wrapper');
  let pastEventsWrapper = document.querySelector('.past-events-wrapper');
  const upcomingEventsArray = [];
  const pastEventsArray = [];

  for (i = 0; i < events.length; ++i) {

    let ele = events[i];
    let eventDate = new Date(ele.dataset.eventdate);
    var now = new Date();
    

    if (eventDate < now) {
      pastEventsArray.push(ele);
    } else if(eventDate > now) {
      upcomingEventsArray.push(ele);
    }

    if (i == events.length - 1) {
      let sortedPastEvents = sortEvents(pastEventsArray);
      for (i = 0; i < sortedPastEvents.length; ++i) {
        pastEventsWrapper.append(sortedPastEvents[i]);
      }
      if (upcomingEventsArray.length > 0) {
        let sortedUpcomingEvents = sortEvents(upcomingEventsArray);
        sortedUpcomingEvents.forEach(element => upcomingEventsWrapper.append(element));
        upcomingEventsWrapper.classList.remove('hide-event-block'); 
      }
    }   
                         
  }

  function sortEvents(eventsToSort) {
    if (eventsToSort) {
      if (eventsToSort.length > 1) {
        eventsToSort.sort(function(a, b) {
          var dateA = new Date(a.dataset.eventdate);
          var dateB = new Date(b.dataset.eventdate);
        
          if (dateA < dateB ) {
            return 1;
          }
          if (dateA > dateB ) {
            return -1;
          }
          return 0;
        });
      }
    }
    return eventsToSort;
  }
                         
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    

  document.addEventListener('DOMContentLoaded', () => {
    [...document.querySelectorAll('.main-header__item-wrapper')].map((elt) =>
      new Navigation(elt)
    );

    if (window.matchMedia('(min-width: 800px)').matches) {
      [...document.querySelectorAll('.header-sticky-logo')].map((elt) =>
        new StickyNavigation(elt)
      );
    }

    if (window.matchMedia('(max-width: 800px)').matches) {
      let mobileNavButton = document.querySelector(".main-header__circle.mobile");
      let mobileNavCloseButton = document.querySelector(".header__search-area.mobile");
      mobileNavButton.addEventListener('click', event => {
        document.querySelector(".mobile-nav").classList.remove("hide");
      });
      mobileNavCloseButton.addEventListener('click', event => {
        document.querySelector(".mobile-nav").classList.add("hide");
       });
    }

  });

  class Navigation {
    constructor(element) {
      this.element = element;
      this.navCircle = this.element.querySelector(".main-header__circle");
      this.navText = this.element.querySelector(".main-header__text");
  
      this.element.addEventListener("mouseenter", (e) => {
        this.navText.classList.add('active');
      });

      this.element.addEventListener("mouseleave", (e) => {
        if( !this.navText.classList.contains('stay') ) {
          this.navText.classList.remove('active');
        }
      });
  
    }
  }

  class StickyNavigation {
    constructor(element) {
      this.element = element;
      document.addEventListener('scroll', function(e) {
        if ((document.body.offsetHeight - window.scrollY) < 800) {
          element.classList.remove('active');
        } else if (window.scrollY > 500) {
          element.classList.add('active');
        } else {
          element.classList.remove('active');
        }
      });
    }
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-one-up"]) return;
  try {
    

document.addEventListener('DOMContentLoaded', () => {
  const homepageOneUpElements = document.querySelectorAll(".homepage-one-up__hide");
  const homepageOneUpRandomNum = Math.floor((Math.random() * homepageOneUpElements.length));
  homepageOneUpElements[homepageOneUpRandomNum].classList.remove("homepage-one-up__hide");
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-three-up-bottom"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const homepageThreeUpBottomElements = document.querySelectorAll(".homepage-three-up-bottom__hide"); 
  const arr = [];
  for(var i = 0; i < homepageThreeUpBottomElements.length; i++) {
    arr.push(i);
  }
  if (homepageThreeUpBottomElements.length >= 3) {
    for(var i = 0; i < 3; i++) {
      const homepageThreeUpBottomRandomNum = Math.floor((Math.random() * arr.length));
      homepageThreeUpBottomElements[arr[homepageThreeUpBottomRandomNum]].classList.remove("homepage-three-up-bottom__hide");
      arr.splice(homepageThreeUpBottomRandomNum, 1);
      console.log(arr);
    }
  }
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    console.log("got here"); 
    let allProducts = document.querySelectorAll(".start-hidden");
    let relatedProductsTotalArray = [...Array(allProducts.length).keys()];
    
    for(i=0; i<3;i++) {
      let randomToShow = Math.floor(Math.random() * relatedProductsTotalArray.length); 
      allProducts[randomToShow].classList.remove('start-hidden');
      let arrayIndex = relatedProductsTotalArray.indexOf(allProducts[randomToShow]);
      if (arrayIndex > -1) {

        relatedProductsTotalArray.splice(arrayIndex, 1);
      }
    }


  });


  } catch(e) { console.error(e); }
})();

})();
